import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWave1 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={900} height={600} {...props}>
        <path
            fill="#EE486F"
            d="m0 174 21.5-4.7c21.5-4.6 64.5-14 107.3-9 42.9 5 85.5 24.4 128.4 23.4 42.8-1 85.8-22.4 128.6-32.9 42.9-10.5 85.5-10.1 128.4-.6 42.8 9.5 85.8 28.1 128.6 32.5 42.9 4.3 85.5-5.7 128.4-7.7 42.8-2 85.8 4 107.3 7l21.5 3V0H0Z"
        />
    </svg>
);
export default SvgWave1;
